import styled, { css } from 'styled-components';

export const OnboardingAutoPayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 488px;
`;

export const AutoPaySuccessModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  max-width: 462px;
`;

export const GraphicContainer = styled.div<{ $enrolled: boolean }>`
  margin: 24px 0 20px;
  svg {
    width: ${({ $enrolled }) => ($enrolled ? '153px' : '204px')};
    height: ${({ $enrolled }) => ($enrolled ? '153px' : '176px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin: 112px 0 40px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin-top: 88px;
  }
`;

export const GraphicContainerModal = styled(GraphicContainer)<{ $isSecondary?: boolean }>`
  margin: 0;

  ${({ $isSecondary }) =>
    $isSecondary &&
    css`
      svg {
        width: 78px;
        height: auto;
      }
    `}
`;

export const OnboardingAutoPayContent = styled.div`
  text-align: left;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  margin: 12px 0 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin: 24px 0 30px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin-bottom: 32px;
  }
`;

export const ContentList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 16px;
  }
`;

export const ContentItem = styled.li`
  font-size: 16px;
  font-weight: 300;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 256px;
  gap: 12px;
`;
